import { AppDate } from '../envTypes';

import { ModelBase } from './base';
import { PayoutBank, PayoutPaypal, PayoutVenmo } from './payment';
import { Profile } from './profile';
import { OrderStatus } from './order';

export interface BalanceChangeTrack {
  withdrawableBalance: number;
  withdrawablePendingBalance: number;
}

export enum BalanceOperation {
  CREATE_ORDER = 'CREATE_ORDER',
  CREATE_TIPPING_ORDER = 'CREATE_TIPPING_ORDER',
  SHIPPO_WEB_HOOK = 'SHIPPO_WEB_HOOK',
  COMMENT_SOLD_FULFILL_WEB_HOOK = 'COMMENT_SOLD_FULFILL_WEB_HOOK',
  FINALIZE_ORDER = 'FINALIZE_ORDER',
  REFUND_ORDER = 'REFUND_ORDER',
  CANCEL_ORDER = 'CANCEL_ORDER',
  MANUAL = 'MANUAL',
  WITHDRAW_CREATE = 'WITHDRAW_CREATE',
  WITHDRAW_REJECT = 'WITHDRAW_REJECT',
  WITHDRAW_FAILED = 'WITHDRAW_FAILED',
  DEDUCT_SHIPPING_COSTS = 'DEDUCT_SHIPPING_COSTS',
  REFUND_SHIPPING_COSTS = 'REFUND_SHIPPING_COSTS',
  DEDUCT_SHIPPING_SURCHARGE = 'DEDUCT_SHIPPING_SURCHARGE',
  ORDER_HOLDING_TRANSFERAL = 'ORDER_HOLDING_TRANSFERAL',
  /**
   * Will deprecated when branch(feat/creator-subscription-my-earnings) deployed
   */
  POP_STORE_CREATOR_SUBSCRIPTION = 'POP_STORE_CREATOR_SUBSCRIPTION',
  POP_STORE_CREATOR_SUBSCRIPTION_SUBSCRIBER = 'POP_STORE_CREATOR_SUBSCRIPTION_SUBSCRIBER',
  POP_STORE_CREATOR_SUBSCRIPTION_FAN = 'POP_STORE_CREATOR_SUBSCRIPTION_FAN',
  POP_STORE_CREATOR_SUBSCRIPTION_VIP = 'POP_STORE_CREATOR_SUBSCRIPTION_VIP',
  POP_STORE_CREATOR_DIGITAL_PRODUCT = 'POP_STORE_CREATOR_DIGITAL_PRODUCT',
  POP_STORE_CREATOR_SUBSCRIPTION_REFUND = 'POP_STORE_CREATOR_SUBSCRIPTION_REFUND',
}

export enum BalanceSourceType {
  WITHDRAW = 'WITHDRAW',
  ORDER = 'ORDER',
  SHIPPING_LABEL = 'SHIPPING_LABEL',
  TIPPING_ORDER = 'TIPPING_ORDER',
  USER = 'USER',
  /**
   * Will deprecated when branch(feat/creator-subscription-my-earnings) deployed
   */
  POP_STORE_CREATOR_SUBSCRIPTION = 'POP_STORE_CREATOR_SUBSCRIPTION',
  POP_STORE_CREATOR_SUBSCRIPTION_SUBSCRIBER = 'POP_STORE_CREATOR_SUBSCRIPTION_SUBSCRIBER',
  POP_STORE_CREATOR_SUBSCRIPTION_FAN = 'POP_STORE_CREATOR_SUBSCRIPTION_FAN',
  POP_STORE_CREATOR_SUBSCRIPTION_VIP = 'POP_STORE_CREATOR_SUBSCRIPTION_VIP',
  POP_STORE_CREATOR_DIGITAL_PRODUCT = 'POP_STORE_CREATOR_DIGITAL_PRODUCT',
}

export interface BalanceChangePayment {
  chargeId?: string;
  subscriptionId?: string;
  invoiceId?: string;
  paymentIntent?: string;
}

// /readonlyProfiles/{userId}/balanceChanges/{auto-id}
export interface BalanceChanges extends ModelBase {
  before: BalanceChangeTrack & {
    balanceChangeId: string | null;
    index?: number;
  };
  operation: BalanceOperation;
  withdrawableAmount: number;
  withdrawablePendingAmount: number;
  sourceType: BalanceSourceType;
  sourceId?: string;
  after: BalanceChangeTrack;
  index?: number;
  note?: string;
  noteBy?: string;
  payment?: BalanceChangePayment;
}

export enum PayoutHistoryChangeStatus {
  approved = 'approved',
  pending = 'pending',
  rejected = 'rejected',
  canceled = 'canceled',
}

export enum PayoutHistoryRequestSourceType {
  admin = 'admin',
  seller = 'seller',
}

export interface PayoutHistory {
  createdAt: AppDate;
  updatedAt?: AppDate;
  before?: PayoutBank | PayoutVenmo | PayoutPaypal;
  after?: PayoutBank | PayoutVenmo | PayoutPaypal;
  operatorId?: string;
  operatorProfile?: Profile;
  userId?: string;
  profile: Profile;
  status?: PayoutHistoryChangeStatus;
  sourceType?: PayoutHistoryRequestSourceType;
}

export enum RecordType {
  SYNC = 'SYNC',
  SHIPPO_WEB_HOOK = 'SHIPPO_WEB_HOOK',
  COMMENT_SOLD_FULFILL_WEB_HOOK = 'COMMENT_SOLD_FULFILL_WEB_HOOK',
  FINALIZE_ORDER = 'FINALIZE_ORDER',
  REFUND_ORDER = 'REFUND_ORDER',
  CANCEL_ORDER = 'CANCEL_ORDER',
}

export interface BalanceChangeRecord {
  withdrawableBalance?: number;
  withdrawablePendingBalance?: number;
  type: RecordType;
  orderId?: string;
  amount: number;
  pendingAmount: number;
  orderStatus?: OrderStatus;
  createdAt: AppDate;
}

export type WithdrawTransactionStatus =
  | 'approved'
  | 'rejected'
  | 'pending'
  | 'failed';

export enum WithdrawTransactionType {
  PslPay = 'pslPay',
  Creator = 'creator',
}

export interface WithdrawTransaction {
  userId: string;
  profile: Profile;
  amount: number;
  balance: number;
  status: WithdrawTransactionStatus;
  note?: string;
  payoutMethodBank?: PayoutBank;
  payoutMethodVenmo?: PayoutVenmo;
  payoutMethodPaypal?: PayoutPaypal;
  createdAt: AppDate;
  updatedAt: AppDate;
  withdrawableAmount?: number;
  withdrawableBalance?: number;
  userAgent?: string;
  idNumber?: number;
  isPslPayPayment?: boolean;
  withdrawType?: WithdrawTransactionType;
  failureMessage?: string;
}
